import {
    EnumInfoUTypes,
    EnumLanguages,
    EnumLogLevel,
    EnumMFAMethods,
    EnumNotificationDeliveryOptions,
    EnumNotificationStatuses,
    EnumNotificationTemplateEditingMode,
    EnumPopupShowStatuses,
    EnumPrintingType,
    EnumSystemOptionDataTypes,
    EnumSystemOptions,
    EnumUserLoginStatus,
    EnumYesNo,
    HistoryEventTypesEnum
} from '@core/framework/sysenums.enum';

export const Resources_EN =
{
    Pages:
    {
        login: 'System Login',
        logout: 'Log off',
        credentials_activity_status: 'User activity status',
        notificationshistory: 'Notifications report',
        notification_dispatches: 'Notification dispatches',
        notification_servers: 'Notification servers',
        notification_templates: 'Notification templates',
        notifications: 'Notifications',
        system_options: 'System options',
        credential_login_history: "Login history Report",
        request_history: "Request history",
        credentials_report: 'Credentials report',
        credentials_creation: 'New credentials assignment',
        data_views: 'Database views management',
        menu: 'Menu',
        remote_request_history: "Remote request history",
        NotificationViewComponent: 'Notification',
        PrintBoxDialogComponent: 'Print',
        SignBoxDialogComponent: 'Sign Document',
        ImageBoxDialogComponent: 'Image',
        PhotoBoxDialogComponent: 'Photo',
        PasswordManageComponent: 'Credentials management',
        CredentialsActivityStatusComponent: 'User activity status',
        NotificationsHistoryComponent: 'Notifications report',
        PreviewDialogComponent: 'Preview',
        NotificationDispatchComponent: 'Notification dispatch',
        NotificationDispatchListComponent: 'Notification dispatches',
        NotificationServerComponent: 'Notification server',
        NotificationServerListComponent: 'Notification servers',
        NotificationTemplateListComponent: 'Notification templates',
        NotificationTemplateComponent: 'Notification template',
        HtmlBoxDialogComponent: 'HTML Editor',
        NotificationTestDialogComponent: 'Notification test',
        NotificationPreviewDialogComponent: 'Notification preview',
        SystemOptionsComponent: 'System options',
        AddSystemOptionDialogComponent: 'Add option',
        BarcodeBoxDialogComponent: 'Scan barcode/QR-code',
        CredentialLoginHistoryComponent: "Login History Report",
        RequestHistoryListComponent: "Request history",
        RequestHistoryComponent: "Request",
        RemoteRequestHistoryListComponent: "Remote request history",
        RemoteRequestHistoryComponent: "Remote request",
        WelcomeUserDialogComponent: "Welcome message",
        HistoryViewComponent: 'Document changes history',
        SystemCredentialsComponent: 'Credentials Report',
        SystemCredentialsCreationComponent: 'New credentials assignment',
        WelcomeMessageConfigDialogComponent: 'Welcome Notification',
        DataViewListComponent: 'Data Views',
        MenuButtonListComponent: 'Main Menu',
        ShareDialogComponent: 'Share',
    },
    Lists:
    {
        Languages:
            [
                {
                    Value: EnumLanguages.Hebrew,
                    Text: "Hebrew",
                },
                {
                    Value: EnumLanguages.English,
                    Text: "English"
                },
                {
                    Value: EnumLanguages.Spanish,
                    Text: "Spanish"
                },
            ],

        NotificationDeliveryOptions: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: 'Email',
                ID: 0
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: 'SMS',
                ID: 1
            },     
            {
                Value: EnumNotificationDeliveryOptions.WhatsApp,
                Text: 'WhatsApp',
                ID: 3
            }
        ],
        NotificationDispatchDeliveryOptions: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: 'Email'
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: 'SMS'
            },     
            {
                Value: EnumNotificationDeliveryOptions.WhatsApp,
                Text: 'WhatsApp'
            },
            {
                Value: EnumNotificationDeliveryOptions.PushMessage,
                Text: 'Push'
            },
        ],
        NotificationTemplateEditingModes: [
            {
                Value: EnumNotificationTemplateEditingMode.None,
                Text: 'None',
                ID: 0,
                SortOrder: 1
            },
            {
                Value: EnumNotificationTemplateEditingMode.Preview,
                Text: 'Preview only',
                ID: 4,
                SortOrder: 2
            },
            {
                Value: EnumNotificationTemplateEditingMode.EditPrefix,
                Text: 'Edit prefix',
                ID: 1,
                SortOrder: 3
            },
            {
                Value: EnumNotificationTemplateEditingMode.EditBody,
                Text: 'Edit body',
                ID: 3,
                SortOrder: 4
            },
        ],
        UserCreationOptions: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: 'Email',
                ID: 0
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: 'Phone',
                ID: 1
            }
        ],
        WelcomeDeliveryOptions: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: 'Email',
                ID: 0,
                SortOrder: 1
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: 'SMS',
                ID: 1,
                SortOrder: 2
            },   
            {
                Value: EnumNotificationDeliveryOptions.WhatsApp,
                Text: 'WhatsApp',
                ID: 3,
                SortOrder: 3
            },
            {
                Value: EnumNotificationDeliveryOptions.DontSend,
                Text: 'Don\'t Send',
                ID: 4,
                SortOrder: 4
            }
        ],
        NotificationTypes: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: 'Email',
                SortOrder: 1,
                index: 0,
                text: 'Email',
                Name: EnumNotificationDeliveryOptions.Email
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: 'SMS',
                SortOrder: 2,
                index: 1,
                text: 'SMS',
                Name: EnumNotificationDeliveryOptions.SMS
            },
            {
                Value: EnumNotificationDeliveryOptions.PushMessage,
                Text: 'Push message',
                SortOrder: 3,
                index: 2,
                text: 'Push message',
                Name: EnumNotificationDeliveryOptions.PushMessage
            },
            {
                Value: EnumNotificationDeliveryOptions.WhatsApp,
                Text: 'WhatsApp',
                SortOrder: 4,
                index: 3,
                text: 'WhatsApp',
                Name: EnumNotificationDeliveryOptions.WhatsApp
            },
            {
                Value: EnumNotificationDeliveryOptions.Share,
                Text: 'Share',
                SortOrder: 4,
                index: 3,
                text: 'Share',
                Name: EnumNotificationDeliveryOptions.Share
            }
        ],
        NotificationStatuses:
            [
                {
                    Value: EnumNotificationStatuses.Draft,
                    Text: "Draft"
                },
                {
                    Value: EnumNotificationStatuses.Sending,
                    Text: "Sending"
                },
                {
                    Value: EnumNotificationStatuses.Failure,
                    Text: "Failure"
                },
                {
                    Value: EnumNotificationStatuses.Sent,
                    Text: "Sent"
                },
            ],
        NotificationPredefinedSmtpServers: [
            {
                Text: "Office 365",
                SMTPServer: "smtp.office365.com",
                SMTPPort: 587,
                SMTPUseSSL: true
            },
            {
                Text: "Gmail",
                SMTPServer: "smtp.gmail.com",
                SMTPPort: 111,
                SMTPUseSSL: true
            },
            {
                Text: "SendGrid",
                SMTPServer: "smtp.sendgrid.com",
                SMTPPort: 111,
                SMTPUseSSL: false
            }
        ],
        NotificationPredefinedSmsServers: [
            {
                Text: "InforU",
                SMSEndpoint: "https://uapi.inforu.co.il/SendMessageXml.ashx",
                SMSToken: 111,
                SMSEndPointIsInforU: EnumInfoUTypes.InforU
            },
            {
                Text: "Unicell",
                SMSEndpoint: "http://api.soprano.co.il/",
                SMSToken: 222,
                SMSEndPointIsInforU: EnumInfoUTypes.Unicell
            }
        ],
        MFAMethods:
            [
                {
                    Value: EnumMFAMethods.None,
                    Text: "None"
                },
                {
                    Value: EnumMFAMethods.Email,
                    Text: "Email"
                },
                {
                    Value: EnumMFAMethods.SMS,
                    Text: "SMS"
                },
                {
                    Value: EnumMFAMethods.WhatsApp,
                    Text: "WhatsApp"
                }
            ],
        ExportMenuItems: [
            {
                SortOrder: 0,
                Value: 1,
                Text: "Excel"
            },
            {
                SortOrder: 1,
                Value: 2,
                Text: "Print"
            }
        ],
        PopupShowStatuses: [
            {
                Value: EnumPopupShowStatuses.None,
                Text: "None"
            },
            {
                Value: EnumPopupShowStatuses.ToShow,
                Text: "To show"
            },
            {
                Value: EnumPopupShowStatuses.Showed,
                Text: "Showed"
            }
        ],
        InfoUTypes: [
            {
                Value: EnumInfoUTypes.Unicell,
                Text: "Unicell"
            },
            {
                Value: EnumInfoUTypes.InforU,
                Text: "InforU"
            }
        ],
        SystemOptions: [
            {
                Value: EnumSystemOptions.AppNameHE,
                Text: 'Application Name Hebrew'
            }, {
                Value: EnumSystemOptions.AppNameEN,
                Text: 'Application Name English'
            }, {
                Value: EnumSystemOptions.AppURL,
                Text: 'Application URL'
            }, {
                Value: EnumSystemOptions.SessionTimeout,
                Text: 'Session timeout'
            }, {
                Value: EnumSystemOptions.SessionExpiry,
                Text: 'Session expiry'
            }, {
                Value: EnumSystemOptions.EnableRequestLogging,
                Text: 'Enable request logging'
            }, {
                Value: EnumSystemOptions.EnableRemoteLogging,
                Text: 'Enable remote logging'
            }, {
                Value: EnumSystemOptions.ShowExpiredTimeoutAlert,
                Text: 'Show expired timeout alert',
                DataType: EnumSystemOptionDataTypes.Boolean,
                SectionName: 'Framework'
            }, {
                Value: EnumSystemOptions.ShowAlmostExpiredTimeoutAlert,
                Text: 'Show almost expired timeout alert'
            }, {
                Value: EnumSystemOptions.IsSupportedCredentialsManagement,
                Text: 'Support credentials management'
            }, {
                Value: EnumSystemOptions.IsSupportedUserWelcome,
                Text: 'Supported user welcome'
            }, {
                Value: EnumSystemOptions.IsSupportedPasswordChange,
                Text: 'Support password change'
            }, {
                Value: EnumSystemOptions.IsSupportedPasswordRecovery,
                Text: 'Support password recovery'
            }, {
                Value: EnumSystemOptions.IsSupportedLoginByOTP,
                Text: 'Support login by otp'
            }, {
                Value: EnumSystemOptions.IsSupportedLoginByPassword,
                Text: 'Support login by password'
            }, {
                Value: EnumSystemOptions.IsAutoCreateCredentials,
                Text: 'Auto create credentials'
            }, {
                Value: EnumSystemOptions.AutoCreateCredentialsType,
                Text: 'Auto create credentials type'
            }, {
                Value: EnumSystemOptions.IsRequireTaxNumberForOTP,
                Text: 'Require tax number for OTP'
            }, {
                Value: EnumSystemOptions.PasswordChangeIntervalDays,
                Text: 'Password change interval, days'
            }, {
                Value: EnumSystemOptions.PasswordComplexityLen,
                Text: 'Password complexity length'
            }, {
                Value: EnumSystemOptions.PasswordComplexityMinChars,
                Text: 'Password complexity minimum char symbols'
            }, {
                Value: EnumSystemOptions.PasswordComplexityMinDigits,
                Text: 'Password complexity minimum digit symbols'
            }, {
                Value: EnumSystemOptions.BadLoginAttemptBeforeLock,
                Text: 'Bad login. Attempt before lock'
            }, {
                Value: EnumSystemOptions.BadLoginAttemptsCheckIntervalMinutes,
                Text: 'Bad login. Attempts check interval, minutes'
            }, {
                Value: EnumSystemOptions.BadLoginAttemptLockouIntervalMinutes,
                Text: 'Bad login. Attempt lockout interval, minutes'
            }, {
                Value: EnumSystemOptions.XFrameOptions,
                Text: 'XFrame blocking options'
            }, {
                Value: EnumSystemOptions.IsDeployedBehindLoadBalancer,
                Text: 'Deployed behind load balancer / proxy'
            }, {
                Value: EnumSystemOptions.IsSupportNotificationMethodEmail,
                Text: 'Support Email notification method'
            }, {
                Value: EnumSystemOptions.IsSupportNotificationMethodSMS,
                Text: 'Support SMS notification method'
            }, {
                Value: EnumSystemOptions.IsSupportNotificationMethodWhatsApp,
                Text: 'Support WhatsApp notification method'
            }, {
                Value: EnumSystemOptions.RetentionPeriodRequests,
                Text: 'Requests Retention Period'
            }, {
                Value: EnumSystemOptions.RetentionPeriodRemoteRequests,
                Text: 'Remote Requests Retention Period'
            }, {
                Value: EnumSystemOptions.RetentionPeriodNotifications,
                Text: 'Notifications Retention Period'
            }, {
                Value: EnumSystemOptions.RetentionPeriodSessions,
                Text: 'Sessions Retention Period'
            }, {
                Value: EnumSystemOptions.SessionFingerprintFreezeTimeout,
                Text: 'Session Fingerprint Freeze Timeout (mins)'
            },
        ],
        UserLoginStatuses: [
            {
                Value: EnumUserLoginStatus.All,
                Text: "All"
            },
            {
                Value: EnumUserLoginStatus.Success,
                Text: "Success"
            },
            {
                Value: EnumUserLoginStatus.Failure,
                Text: "Failure"
            }
        ],
        IsSuccessStatuses: [
            {
                Value: true,
                Text: "Success"
            },
            {
                Value: false,
                Text: "Failure"
            },
        ],
        HistoryEventTypesEnum: [
            {
                Value: HistoryEventTypesEnum.FieldChange,
                Text: "Field changed"
            },
            {
                Value: HistoryEventTypesEnum.RowAdded,
                Text: "Row added"
            },
            {
                Value: HistoryEventTypesEnum.RowDeleted,
                Text: "Row deleted"
            },
            {
                Value: HistoryEventTypesEnum.Special,
                Text: "Special"
            }
        ],
        YesNo:
        [
            {
                Value: EnumYesNo.Yes,
                Text: 'Yes'
            },
            {
                Value: EnumYesNo.No,
                Text: 'No'
            }
        ],
        PageTypes: [
            {
                Value: EnumPrintingType.None,
                Text: 'None'
            },
            {
                Value: EnumPrintingType.Report,
                Text: 'Report'
            },
            {
                Value: EnumPrintingType.Entity,
                Text: 'Entity'
            }
        ],
        LogLevels: 
        [
            {
                Value: EnumLogLevel.Warning,
                Text: 'Warning'
            },{
                Value: EnumLogLevel.Info,
                Text: 'Info'
            },{
                Value: EnumLogLevel.Error,
                Text: 'Error'
            },
        ]
    },
    Translations:
    {
        lblLanguage: "Language",
        lblUserName: "User name",
        lblPassword: "Password",
        titleLogin: "System Login",
        btnLogin: "Login",
        btnLogout: 'Logout',
        btnChangePassword: 'Change password',
        btnContactUs: "Contact us",
        btnRecoverPassword: 'Forgot password',
        lblSaveCredentials: 'Remember Me',
        titleLogout: "Logoff",
        titleLogoutLong: "Logged off succesfully",
        titleLogoutLast: "You are being redirected to the login screen",
        titleSessionExpiredTitle: "Session Expired",
        titleSessionExpired: "You have been logged off due to inactivity or a change in user credentials on the server. Please log in again ",
        titleChangePasswordTitle: "Change password",
        titleChangePassword: "Enter a new password. The password should be a strong one, and follow the rules set by your IT staff",
        titleChangePasswordTitle2: "Change expired password",
        titleException: "System error",
        titleExceptionLong: "Error details are displayed below. Please send them to the system administrator.\nUnexpected error has occured:",
        titleComingSoonTitle: "This feature is coming soon",
        titlePasswordChanged: 'The password has been changed succesfully. Please use your new password to login again',
        titleIdentification: 'User identification',
        titlePasswordEntry: 'New password entry',
        titleRecoverPasswordTitle: 'Forgot password recovery',
        titleWelcomePasswordTitle: 'First system login',
        titleRecoverPassword1: 'Enter your user name',
        titleRecoverPassword2: 'You can recover your forgotten password, as long as you have access to the email or phone that is saved in your account',
        titleRecoverPassword3: 'To change the password please enter the verification code sent to you',
        titleRecoverPassword4: 'Enter a new password. The password should be a strong one, and follow the rules set by your IT staff',
        titleWelcomePassword2: 'Welcome! Please enter the username and the verification code you have received, in order to proceede to setting up your new password',
        titleWelcomePassword3: "Enter a new password. The password should be a strong one, and follow the rules set by your IT staff. From now on, you will use this password to enter the system",
        btnReEntry: "Re-Login",
        genOK: 'OK',
        genYes: "Yes",
        genNo: "No",
        genCancel: "Cancel",
        genNoData: "No data exists",
        genPrint: 'Print',
        genSign: 'Sign',
        genReset: 'Reset',
        genTakePhoto: 'Take Photo',
        genSavePhotos: 'Save photos',
        genDownload: 'Download',
        msgSignHere: 'Please draw your signature inside the square',
        msgSignatureRequired: 'You must provide your signature to continue',
        msgPasswordsDontMatch: 'Password and password confirmation do not match',
        errorNetwork: "Server communication error - check your network connection",
        errorSessionExpired: "Session expired due to inactivity",
        errorUserInvalid: "User details have changes. Please log in again",
        errorNotInitialized: "Unable to login since system settings were not loaded propely. Please reload the page",
        errorUnexpected: "@@@Unexpected server error has occured@@@: {0}",
        errorUnauthorized: "User is not authorized for this operation",
        errorPasswordExpired: "Password has expired. Please choose a different password",
        msgFinishEditing: "Please finish editing current line before adding the new one",
        errorUserNameNotFound: "User name not found",
        errorIsNotExistsPhoneAndEmail: "No email or phone is defined. Contact support",
        errorSessionIsFrozen: "Session is frozen due using the same credential on another device",
        lblDay1: "Sunday",
        lblDay2: "Monday",
        lblDay3: "Tuesday",
        lblDay4: "Wednesday",
        lblDay5: "Thursday",
        lblDay6: "Friday",
        lblDay7: "Saturday",
        lblDay1s: "Sun",
        lblDay2s: "Mon",
        lblDay3s: "Tue",
        lblDay4s: "Wed",
        lblDay5s: "Thu",
        lblDay6s: "Fri",
        lblDay7s: "Sat",
        msgSuccess: "Operation completed succesfully",
        msgNotPerformed: "Unable to complete operation",
        lblTimes: 'times',
        lblUser: "Standard user",
        btnCancelDocument: 'Cancel Document',
        lblBy: 'By',
        titleCreatedBy: 'Created by',
        titleCreated: 'Created',
        titleCreatedAt: 'Created at',
        titleAgo: 'Ago',
        lblAgo: 'ago',
        lblSearch: 'Search',
        lblCloseSearch: 'Close search',
        lblColumnChooser: 'Show Column Chooser',
        lblColumnHiding: 'Switch Column Hiding',
        lblShowGridFilter: 'Show Advanced Filters',
        lblHideGridFilter: 'Hide Advanced Filters',
        lblExcel: 'Export to Excel',
        lblPdf: 'Export to PDF',
        lblViewList: 'View as list of cards',
        lblViewGrid: 'View as table',
        lblDisplayUserName: 'User name',
        lblLastUseDate: 'Last action at',
        lblLastUseBefore: 'Last action before',
        progressIndicator: 'Transferring data.. Please wait',
        lblUpdated: 'Updated',
        lblNoSorting: '- Default -',
        lblVersion: 'Version',
        lblDateIsNull: "Date is null",
        lblDateApproximate: "{0} {1} {2}",
        f702: "less than a minute",
        f703: "5 minutes",
        f704: "10 minutes",
        f705: "15 minutes",
        f706: "half an hour",
        f707: "less than an hour",
        f709: "hour and a half",
        f710: "more than two hours",
        f711: "{0} hours",
        f712: "day",
        f713: "two days",
        f714: "{0} days",
        f715: "over a week",
        f716: "more than two weeks",
        f717: "{0} weeks",
        f718: "over a month",
        f720: "two months",
        f721: "{0} months",
        f722: "over a year",
        f723: "more than two years",
        f724: "{0} years",
        f725: "less than a day",
        lblOldPassword: 'Old password',
        lblNewPassword1: 'New password',
        lblNewPassword2: 'Confirm password',
        lblRecoveryType: 'Password recovery method',
        lblRecoveryPhone: 'Phone number for password recovery',
        lblRecoveryEmail: 'Email address for password recovery',
        btnSendNotificationDispatch: 'Send',
        btnSendRecoveryCode: 'Send verification code',
        btnCheckUserName: 'Recover password',
        btnBackToLogin: 'Back to login page',
        lblRecoveryToken: 'Verification code',
        btnResend: 'Send again',
        btnSaveChanges: 'Save changes',
        btnGeneratePassword: 'Generate password',
        btnCreateCredentials: 'Create credentials',
        btnUnlockUser: 'Unlock user',
        lblDisplayUsername: 'Display user name',
        lblDisplayUserDescription: 'Display user description',
        lblCredentialsNotExist: 'User not yet created',
        lblPendingWelcome: 'User pending activation through welcome link',
        titleUserInformation: 'User Information',
        errorMaxSizeUploadError: 'Size of some selected files is bigger that {0} and they are automatically excluded from the selection.',
        msgFileSizeRestriction: 'Max file size is {0}.',
        btnSelectFiles: 'Select files',
        btnMakePhoto: 'Make photo',
        lblAttachFileSize: 'File size',
        lblFilters: 'Filters',
        lblAt: 'At',

        lblObjectName: 'Object name',
        lblIsOverride: 'Is Overriden',
        lblValidation: 'Is Valid',
        lblDViewsDBDuration: 'Original Duration',
        lblXViewsDBDuration: 'Overriden Duration',
        lblCheckPerformance: 'Check Performance',
        lblValidateViews: 'Validate structure',
        lblViewError: 'Error',

        lblLoginOTPSendMethod: 'Send one time password via',
        lblLoginOTPEmail: 'Email address for send one time password',
        lblLoginOTPPhone: 'Phone number for send one time password',
        lblLoginOTPOTP: 'One time password',
        lnkLoginByOTP: 'Login by one time password',
        msgNotificationSent: 'Notification is sent',
        btnLoginOtpSendOtp: 'Send password',
        lnkLoginByPassword: 'Login by password',

        lblApply: 'Apply',
        lblTaxNumber: 'Tax number',

        lblIsActive: 'Active',
        lblEmail: 'Email',
        lblPhone: 'Phone',
        lblIsPendingWelcome: 'Is Pending Welcome',
        lblIsOnline: 'Is Online',
        lblIsLockedOut: 'Is Locked Out',
        lblCreateCredentials: 'Create Credentials',
        lblCredentialFilter: 'Credential Filter',

        msgRouteNotFound: 'Route not found',
        btnReload: 'Reload',
        lblHideColumn: 'Hide Column',
        lblShowHiddenColumns: 'Show Hidden Columns',

        lblName: 'Name',
        lblDescription: 'Description',

        msgLoading: "Processing, please wait",
        lblSentDate: "Sent date",
        lblSentBy: "Sent by",
        lblEntryID: "ID",
        lblFromAddress: "From Address",
        lblFromDisplayAddress: "From name",
        lblAddress: "Address",
        lblSubject: "Subject",
        lblMailBody: "Body",
        lblDeliveryOption: "Delivery option",
        lblSendNotificationBy: "Send notification by",
        lblUsernameCreationOption: 'Username creation by',
        lblStatus: "Status",
        lblToAddress: "To",
        lblCCAddress: "CC",
        lblBccAddress: "BCC",
        lblFailureDescription: "Failure description",
        lblNotificationTemplate: "Template name",
        lblFrom: "From ",
        lblUntil: "Until ",

        lblAdd: "Add",
        lblClear: "Clear",
        lblCompactMode: "Compact Mode",

        lblSessionAlmostExpiredTitle: "Session will expire soon",
        lblSessionAlmostExpiredPrompt: "Long period of inactivity was detected. Your session will expire soon",
        lblSessionExpiredTitle: "Session expired",
        lblFirstDate: "First Date",
        lblLastDate: "Last Date",
        lblSessionExpiredPrompt: "You session has expired. You will be automaticaly re-directed to login page.",

        lblNotificationContent: "Notification Content",
        lblGeneral: "General",
        lblOptions: "Options",
        lblCustom: "Custom",

        lblMFACode: "Code",
        titleMFACodeOnEmailSent: "The one-time password was sent to your email. Enter it below",
        titleMFACodeOnPhoneSent: "The one-time password was sent to your mobile. Enter it below",

        lblMFAMethod: "Multi-factor authentication",
        Month_1: "January",
        Month_2: "February",
        Month_3: "March",
        Month_4: "April	",
        Month_5: "May",
        Month_6: "June",
        Month_7: "July",
        Month_8: "August",
        Month_9: "September",
        Month_10: "October",
        Month_11: "November",
        Month_12: "December",

        lblExport: "Export",
        lblCredentialType: "Credential Type",
        lblIsRestrictByIP: "Restrict by IP",
        lblIsExcludeFromMFA: "Exclude from MFA",
        lblIPRangeStart: "IP range start",
        lblIPRangeEnd: "IP range end",
        lblIPErrorMessage: "An IP address must have &#34;000.000.000.000&#34; format",
        msgIPRangesIsEmpty: "You have to add at least one IP address/range",
        msgIPRangeIsEmpty: "Enter a valid IP address/range",
        msgPasswordMinLength: "The password length must be at least {0} symbols.",
        msgPasswordMinCountDigits: "The password must contain at least {0} digits.",
        msgPasswordMinCountLetters: "The password must contain at least {0} letters.",
        msgPasswordComplexityRequirement: "The password length must be at least {0} symbols long, with minimum {1} digits and {2} letters",
        errorOnlyImageAllowed: "Only images allowed.",
        btnClose: "Close",
        lblPhoto: "Photo",

        lblDragAndDrop: "You can drag & drop files here",
        errorRequiredMessage: "Field is required",
        titleDuplicate: "Duplicate",
        lblAllNotifications: "All notifications",

        lblSMTPServer: "SMTP Server",
        lblSMTPPort: "SMTP Port",
        lblSMTPUserName: "SMTP Username",
        lblSMTPPassword: "SMTP Password",
        lblSMTPUseSSL: "SMTP Use SSL",
        lblSMSEndpoint: "SMS Endpoint",
        lblSMSUserName: "SMS Username",
        lblSMSPassword: "SMS Password",
        lblSMSToken: "SMS Token",
        lblSMSEndPointIsInforU: "SMS Provider",

        titleTemplateInformation: "Notification template information",
        titleEmailInformation: "E-mail template settings",
        lblFromEmail: "From e-mail",
        lblFromEmailDisplay: "From e-mail display",
        titlePhoneInformation: "SMS template settings",
        lblNotificationServer: "Notification server",
        lblFromPhone: "From phone",
        lblSMSBody: "SMS body",
        titlePushMessagesInformation: "Push messages template settings",
        lblPushMessageBody: "Push message body",
        lblHTMLBody: "HTML body",
        btnSave: 'Save',
        titleDelete: 'Delete',
        lblUseDefault: 'Use default',
        lblNoUnreadMessages: 'No unread messages',
        lblTo: 'To',
        lblPushMessageContent: 'Push message content',
        lblSmsMessageContent: 'SMS message content',
        lblIsAutomatic: 'Is automatic',
        lblSystem: 'System',
        lblPopupShowStatus: 'Popup show status',
        lblEmailContent: 'Email content',
        btnShowInEditor: 'Show in editor',
        titleLeavePageConfirmation: 'Data will be lost, do you want to continue?',
        btnLogOff: 'Log Off',
        btnStayConnected: 'Stay Connected',
        btnGoToHomePage: 'Go To Home Page',
        lblReadDate: 'Read date',
        msgDeleteNotificationTemplateQuestion: 'Notification template could be used in the application. Are you sure want to delete it?',
        lblNotificationServerWrong: 'Notification server configuration is incorrect. Please make changes and try again',
        msgInvalidEmail: 'Email is invalid or incorrect format',
        btnTestServer: 'Test server',
        lblMIDIsMissing: "MID is missing",
        lblEnterMID: "Enter new MID code.",
        btnShowPreview: "Show preview",
        lblIsServer: "Server",
        lblIsClient: "Client",
        lblModuleName: "Module",
        lblLogin: "Login",
        lblFramework: "Framework",
        lblOption: "Option",
        lblValue: "Value",
        lblSectionName: "Section",
        lblAddOption: 'Add option',
        msgOptionAlreadyExists: 'Option already exists',
        msgOptionEmpty: 'Option {0} is empty',
        lblBadLogin: 'Bad login',
        msgRemoveOption: "Are you sure you want to delete the Option '{0}'?",
        titleEmailConfiguration: "E-mail Configuration",
        titleSMSConfiguration: "SMS Configuration",
        msgDeleteNotificationServerQuestion: "Notification server could be used in the application. Are you sure want to delete it?",
        msgNoData: "No Data",
        lblEmailHeader: "Email Header",
        lblConfigure: "Configure",
        lblDefaultFromAddressForInforU: "Test",
        lblDefaultFromAddressForUnicel: "0509999999",
        lblInforUFromPhoneValidationTooltip: "Please enter a white-listed phone number of name up to 11 characters in english",
        lblNotifications: "Notifications",
        lblMinimize: "Minimize",
        lblShowMore: "Show more",
        titleWhatsAppInformation: "WhatsApp template settings",
        lblWhatsAppBody: "WhatsApp Message Body",
        lblWhatsAppApiKey: "WhatsApp Api Key",
        lblWhatsAppEndpoint: "WhatsApp Endpoint",
        titleWhatsAppConfiguration: "WhatsApp Configuration",
        titleNotificationDispatchList: "Notification dispatch list",
        titleNotificationServerList: "Notification server list",
        titleNotificationTemplateList: "Notification template list",

        lblPoweredBy: "Powered by Menahel4U",
        titleChooseOption: "Choose option",
        titleWebAPIAllowedIPs: "Allowed IPs",
        lblIpAddress: "IP Address",
        lblLoginDate: "Login Date",
        lblPrint: "Print",
        lblDateFrom: 'Date From',
        lblDateTo: 'Date To',
        lblDate: "Date",
        msgCouldNotStartVideoError: 'Camera is not available',
        msgCameraPermissionDenied:'Camera permission is denied',
        lblCameraModeVideo: 'Video',
        lblCameraModePhoto: 'Photo',
        titlePreview: 'Preview',
        msgLogoutQuestion: 'Are you sure you want to logout?',
        lblGroupPanel: 'Drag column to group',
        lblExpandAll: 'Expand All',
        lblMultiEmailError: 'Value is invalid. Use symbol ; as email separator',
        msgPhotoMinCountError: 'The minimum count is {0}',
        msgPhotoMaxCountError: 'The maximum count is {0}',
        lblRestoreDefaultView: "Restore default view",
        lblStartDate: "Start date",
        lblDuration: "Duration",
        lblController: "Controller",
        lblAction: "Action",
        lblMethod: "Method",
        lblStatusCode: "Status code",
        lblRequestData: "Request data",
        lblQueryString: "Query string",
        lblBody: "Body",
        lblResponse: "Response",
        msgTextCopied: "Text copied",
        lblCopy: "Copy",
        btnGoToLoginHistory: "Go to login history",
        btnGoToRequestsHistory: "Go to requests history",
        btnManageCredentials: "Manage Credentials",
        btnGoToCredentialsReport: "Go to credentials report",
        btnWelcomeUser: "Send welcome message",
        lblTestFromPhone: "From phone",
        lblHistory: "Changes log",
        lblNewValue: "New value",
        lblOldValue: "Old value",
        lblFieldCaption: "Field",
        lblDocumentCaption: " Document",
        lblHistoryLineAdded: "{0} {1} was added.",
        lblHistoryLineRemoved: "{0} {1} was removed.",
        lblHistoryLineNumber: "{0} {1}",
        lblHistoryNotFound: "No changes found.",
        lblHistoryChangeAdded: "{0} {1} was created",
        lblHistoryChangeRemoved: "{0} {1} was deleted",
        msgLoadingPDF: 'Loading PDF file...',
        lblImpersonatedBy: 'Impersonated By',
        lblIsUserCustomTemplate: "User custom template",
        msgIsUserCustomTemplateEnable: "If the option 'Editable' is enabled, you will be able to change the template manually, but the system won't be able to update it automatically",
        btnEnableEditable: "Enable editable",
        btnDisableEditable: "Disable editable",
        msgScreenSizeChangedRefresh: 'Screen size is changed. Please refresh browser window.',
        msgOrientationChangedRefresh: 'Orientation is changed. Please refresh browser window.',
        lblDeliveryMethod: 'Delivery Method',
        lblNotificationDispatch: 'Notification Dispatch',
        lblRecipients: 'Recipients',
        lblPreview: 'Preview',
        msgRecipientsAreEmpty: 'You have to add at least one recipient',
        lblCreatedBy: 'Created by',
        btnCancelNotifications: 'Cancel notifications',
        lblCancelNotificationsPrompt: 'You are going to cancel unread Push notifications. Do you want to proceed?',
        lblNotificationMessage: 'Notification Message',
        lblIsDeleted: 'Deleted',
        lblShareMethodEmail: 'Email',
        lblShareMethodSms: 'SMS',
        lblShareMethodWhatsapp: 'WhatsApp',
        lblShareMethodPrint: 'Print',
        lblShare: 'Share',
        lblEntityType: 'Entity type',
        lblPageName: 'Page',
        btnSend: 'Send',
        lblChooseTemplate: 'Choose template',
        lblShareMethodDownload: 'Download',
        lblShareMethodShare: 'Share',
        lblUploadCrystalTemplate: 'Upload crystal tempalte',
        lblNotificationTemplateEditingMode: 'Body editing mode',
        msgShareNotificationTemplateNotFoundError: 'Notification templates are not configured for this page',
        btnShare: 'Share',
        msgNotificationTemplatePrefixNotFoundError: '$PrefixBody$ param is missing',
        lblPrefixBody: 'Prefix body',
        lblIsSharePdf: 'Share PDF',
        lblFileNameFormat: 'File name format',
        lblEntityBindingPageType: 'Bind to',
        titleEntityBindingInformation: 'Entity binding',
        msgNotificationTemplateFileMissingError: 'Crystal report template is missing',
        lblSharedFile: 'Shared file',
        msgNotificationTemplateEmptyError: 'Cannot save empty template',
        lblIsSupportEmail: 'Support Email',
        lblIsSupportSMS: 'Support SMS',
        lblIsSupportWhatsapp: 'Support Whatsapp',
        lblIsSupportPush: 'Support push',
        lblIsSupportSharing: 'Support sharing',
        lblIsShareByEntities: 'Share by entities',
        ttlLogs: "Logs",
        lblObjectType: "Object type",
        lblObjectID: "Object ID",
        lblLevel: "Level",
        lblNotAssigned: "- Unassigned -",
        msgNotificationSentTo: 'Notification is sent to {0}',
        lblHeader: 'Header',
    }
};
